module.exports = __webpack_public_path__ + "static/media/career2.e08d9e33.jpg";